export function calculateAge(birthDate: Date, now: Date = new Date()): number {
  const birth = new Date(birthDate)
  if (isNaN(birth.getTime())) return -1
  let age = now.getFullYear() - birth.getFullYear()
  const monthDiff = now.getMonth() - birth.getMonth()
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birth.getDate())) {
    age--
  }
  return age
}

export function isAtLeastYears(birthDate: Date, years: number, now: Date = new Date()): boolean {
  return calculateAge(birthDate, now) >= years
}

export function isAtLeast18(birthDate: Date, now: Date = new Date()): boolean {
  return isAtLeastYears(birthDate, 18, now)
}
